// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfigSTSS = [
  {
    title: 'Профіль',
    path: '/student/profile',
    icon: icon('ic_user'),
  },
  {
    title: 'Self study',
    path: '/student/selfstudy',
    icon: icon('ic_analytics'),
  },
];

export default navConfigSTSS;
